// utils/storage.js
import crypto from "./crypto"
const isECB = process.env.VUE_APP_CACHE_ENCRYPT
const Storage = {

    /**
       * 设置缓存
       * @param {String} key 缓存键
       * @param {Any} value 缓存值
       * @param {Number} expire 过期时间（秒），不传则不过期
       * @param {Boolean} isSession 是否使用 sessionStorage，默认 false 使用 localStorage
       */
    sessionSet(key, value, expire = 0) {
        const storage = sessionStorage;
        const data = {
            value,
            expire: expire ? Date.now() + expire * 1000 : null
        };
        var str = JSON.stringify(data)
        storage.setItem(key, isECB ? crypto.encryptECB(str) : str);
    },
    sessionGet(key) {
        const storage = sessionStorage;
        const item = storage.getItem(key);
        if (!item) return null;
        try {

            const data = JSON.parse(isECB ? crypto.decryptECB(item) : item);
            if (data.expire && Date.now() > data.expire) {
                storage.removeItem(key); // 过期自动删除
                return null;
            }
            return data.value;
        } catch (e) {
            return null;
        }
    },

    /**
     * 设置缓存
     * @param {String} key 缓存键
     * @param {Any} value 缓存值
     * @param {Number} expire 过期时间（秒），不传则不过期
     * @param {Boolean} isSession 是否使用 sessionStorage，默认 false 使用 localStorage
     */
    set(key, value, expire = 0, isSession = false) {
        const storage = isSession ? sessionStorage : localStorage;
        const data = {
            value,
            expire: expire ? Date.now() + expire * 1000 : null
        };
        var str = JSON.stringify(data)
        storage.setItem(key, isECB ? crypto.encryptECB(str) : str);
    },

    /**
     * 获取缓存
     * @param {String} key 缓存键
     * @param {Boolean} isSession 是否使用 sessionStorage
     * @returns {Any | null}
     */
    get(key, isSession = false) {
        const storage = isSession ? sessionStorage : localStorage;
        const item = storage.getItem(key);
        if (!item) return null;

        try {
            const data = JSON.parse(isECB ? crypto.decryptECB(item) : item);
            if (data.expire && Date.now() > data.expire) {
                console.log('cache 过期')
                storage.removeItem(key); // 过期自动删除
                return null;
            }
            return data.value;
        } catch (e) {
            return null;
        }
    },

    /**
     * 删除缓存
     * @param {String} key 缓存键
     * @param {Boolean} isSession 是否使用 sessionStorage
     */
    remove(key, isSession = false) {
        const storage = isSession ? sessionStorage : localStorage;
        storage.removeItem(key);
    },

    /**
     * 清空缓存
     * @param {Boolean} isSession 是否使用 sessionStorage
     */
    clear(isSession = false) {
        const storage = isSession ? sessionStorage : localStorage;
        storage.clear();
    }
};

export default Storage;
